module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//13.jpg?d1272451ff9c905c944dfc7eec7c3278";